<template>
	<div class="template-viewer-wrapper elevation-3">
		<div class="conv-title">
			{{ $store.state.bot.botTitle}}
			<p class="conv-status">Online</p>
		</div>

		<div class="msg-preview" v-if="(!loading && (init && init.length > 1) || (body && body.text.length))">
			<label>Preview</label>
			<div class="triangle-left" />
			<v-card class="msg-card elevation-0">
				<v-card-text class="pa-1" v-if="header && header.format === 'IMAGE'">
					<v-img
						class="msg-img" :src="header.url && header.url.length ? header.url : '/img/wa-img-ph.png'"
						aspect-ratio="1.8"
						position="center"/>
				</v-card-text>
				<v-card-text class="pa-1" v-if="header && header.format === 'DOCUMENT'">
					<v-img class="msg-img" src="/img/wa-doc-ph.png" aspect-ratio="1.8"/>
					<!-- <span class="botter-doc-icon" style="background-color: #E9EEF1;" /> -->
				</v-card-text>
				<v-card-title v-if="header && header.format === 'TEXT'" class="px-2 pt-2 pb-0">
					<b>{{ header.text }}</b>
				</v-card-title>
				<v-card-text
					v-if="body && body.text.length || footer && footer.text.length"
					:class="[
						{ 'py-0': (header && header.type !== 'DOCUMENT' && header.type !== 'IMAGE') },
						{ 'pt-2 pb-0': !header && body && body.text.length },
						{ 'py-2': !header && (!body || !body.text.length) },
						'px-2',
						'template-viewer-msg-body'
					]">
					{{ body.text }}
					<div v-if="footer && footer.text.length" class="my-0 py-0">
					   <small class="grey--text text-darken--3 py-0 my-0">{{ footer.text }}</small>
					</div>
				</v-card-text>
				<v-card-actions class="px-2 py-0">
					<v-spacer />
					<small style="float: right" class="grey--text text-darken--3">{{ $moment().format('h:mm A') }}</small>
				</v-card-actions>
			</v-card>
			<div class="msg-buttons-container" v-if="buttons">
				<v-layout v-if="buttons.buttons && buttons.buttons.length" class="px-0">
					<v-flex
						v-for="(button, b) in buttons.buttons"
						:xs6 = "buttons.buttons.length > 1 && b !== 2"
						v-if="b < 2"
						:class="[
						 { 'px-0': buttons.buttons.length === 1 },
						 { 'pl-0 pr-1': buttons.buttons.length > 1 && b === 0 },
						 { 'pr-0 pl-1': buttons.buttons.length > 1 && b === 1 },
						]">
						<v-btn
						    :href="button.PHONE_NUMBER ? `tel: ${button.PHONE_NUMBER}` : button.URL"
							color="white"
							class="msg-action-btn"
							block>{{ button.text }}</v-btn>
					</v-flex>
				</v-layout>
				<v-layout v-if="buttons.buttons && buttons.buttons.length > 2" class="px-0 my-0" style="margin-top: -5px !important;">
					<v-flex class="px-0">
						<v-btn color="white" class="msg-action-btn" block>{{ buttons.buttons[2].text }}</v-btn>
					</v-flex>
				</v-layout>
			</div>
		</div>
	</div>
</template>

<script>
export default {

  name: 'TemplateViewer',
  props: {
  	init: {
  		type: Array,
  		default() {
  			return []
  		}
  	},
  	params: {
  		type: Object,
  		default: null
  	},
  	loading: {
  		type: Boolean,
  		default: false
  	}
  },
  data () {
    return {

    }
  },
  watch: {
  	componentsFormatted: {
  		deep: true,
  		immediate: true,
  		handler(val) {
  			this.$emit('components-format', val)
  		}
  	},
  },
  computed: {
  	header() {
  		if(!this.init) return null
  		const filtered = this.init.filter(c => c.type === 'HEADER')
  	    if(filtered.length) return filtered[0]
  	    return null
  	},
  	body() {
  		if(!this.init) return null
  		const filtered = this.init.filter(c => c.type === 'BODY')
  	    if(filtered.length) {
  	    	let result = filtered[0]
  	    	// console.log(result)
  	    	if(this.params && this.params.body) {
  	    		let i = 0
  	    		for(i = 0; i < this.params.body.length; i += 1) {
  	    			if(this.params.body[i].value && this.params.body[i].value.length) {
  	    				result.text = result.text.split(this.params.body[i].attribute.slice(5))
  	    				.join(this.params.body[i].value)
  	    			}
  	    		}
  	    	}
  	    	return result
  	    }
  	    return null
  	},
  	footer() {
  		if(!this.init) return null
  		const filtered = this.init.filter(c => c.type === 'FOOTER')
  	    if(filtered.length) return filtered[0]
  	    return null
  	},
  	buttons() {
  		if(!this.init) return null
  		const filtered = this.init.filter(c => c.type === 'BUTTONS')
  	    if(filtered.length) return filtered[0]
  	    return null
  	},
  	componentsFormatted() {
  		return {
  			header: this.header,
  			body: this.body,
  			footer: this.footer,
  			buttons: this.buttons
  		}
  	}
  }
}
</script>

<style lang="scss" scoped>
.template-viewer-wrapper {
	background: url(/img/whatsapp-ss.jpg);
	background-size: contain;
	background-repeat: none;
	width: 292px;
	height: 613px;
	border-radius: 8px;
	font-family: sans-serif;
}
.conv-title {
	position: absolute;
	margin-top: 32px;
	margin-left: 58px;
	color: white;
	font-weight: bold;
	font-size: 14px;
	.conv-status {
		font-size: 10px;
		font-weight: normal;
		padding-top: 0 !important;
		margin-top: -4px !important;
		font-family: sans-serif !important;
	}
}
.msg-preview {
	position: absolute;
	margin-top: 80px;
	margin-left: 20px;
	label {
		font-weight: bold;
	}
	.msg-card {
		width: 250px;
		border-radius: 5px;
		border-top-left-radius: 0;
		padding: 0 0 0 0;
		max-height: 350px;
		overflow-y: auto;
	}
}
.msg-img {
	border-radius: 5px;
	background-color: #fff;
}
.triangle-left {
	width: 0;
	height: 0;
	border-top: 0px solid transparent;
	border-right: 14px solid #fff;
	border-bottom: 10px solid transparent;
	margin-top: 0px;
	position: absolute;
	margin-left: -10px;
	z-index: 3;
}
.msg-buttons-container {
	width: 250px;
}
.msg-action-btn {
	color: #44B5F5;
	font-weight: bold;
	margin-left: 0;
	margin-right: 0;
}
.template-viewer-msg-body {
	word-break: break-word;
}
</style>